import React from "react";

type Props = {
  screenshotSrc: string;
  screenshotAlt?: string;
  className?: string;
};

export const IPhoneFrame = ({ screenshotSrc, screenshotAlt = "", className }: Props) => {
  return (
    <div className={className ? `rt-iphone ${className}` : "rt-iphone"}>
      <div className="rt-iphone-side rt-iphone-side-left" aria-hidden="true" />
      <div className="rt-iphone-side rt-iphone-side-right" aria-hidden="true" />

      <div className="rt-iphone-body">
        <div className="rt-iphone-notch" aria-hidden="true">
          <div className="rt-iphone-speaker" />
          <div className="rt-iphone-camera" />
        </div>

        <div className="rt-iphone-screen">
          <img src={screenshotSrc} alt={screenshotAlt} />
        </div>

        <div className="rt-iphone-home-indicator" aria-hidden="true" />
      </div>
    </div>
  );
};
